import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'EvoCam',
      href: '/de/Software/macOS/EvoCam/',
    },
    {
      text: 'SecuritySpy',
      href: '/de/Software/macOS/SecuritySpy/',
    },
    {
      text: 'Sighthound',
      href: '/de/Software/macOS/Sighthound/',
    },
    {
      text: 'VLC Player',
      href: '/de/Software/macOS/VLC_Player/',
    },
    {
      text: '◄ macOS',
      href: '/de/Software/macOS/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Software Platform for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}
